import React from "react";  

const About = () => {
    return(
        <div className="about">
            I wanted to build a application to pick mean ideas
        </div>
    )
}


export default About;